var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { ref: "esignH5Div", staticClass: "esignH5" }, [
    _c(
      "div",
      { staticClass: "signName-box" },
      [
        _c("esign", {
          ref: "signName",
          attrs: {
            showCreateBtn: true,
            width: _vm.clientWidth,
            height: _vm.clientHeight,
          },
          on: { esignHandle: _vm.esignHandle },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }